import type { SVGProps } from 'react';

const SvgHomeLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M11.1943 4.10547C11.6857 3.79279 12.3143 3.79279 12.8057 4.10547L19.8057 8.55957C20.2382 8.83493 20.5 9.31243 20.5 9.8252V19C20.5 19.8284 19.8284 20.5 19 20.5H5C4.17157 20.5 3.5 19.8284 3.5 19V9.8252C3.5 9.31243 3.76178 8.83493 4.19434 8.55957L11.1943 4.10547Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M8 16H16' stroke='currentColor' strokeLinecap='round' />
  </svg>
);
export default SvgHomeLt;
